







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import DataCell from "./DataCell.vue";
import { CellData, DataQualityHeader, DataQualityRow } from "@/types/dataQuality/dataQualityTable";

@Component({
  components: {
    DataCell,
  },
})
export default class FleetOverviewTable extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: Boolean;
  @Prop({ type: Array, default: () => [] }) headers!: DataQualityHeader[];
  @Prop({ type: Array, default: () => [] }) rows!: DataQualityRow[];
  @Prop({ type: Array, default: () => [] }) links!: string[] | null;

  sortBy = "";
  isLoadingTextDisplay = false;
  sortDesc = false;
  pageLimit = 10;

  onIndicatorClicked(data: CellData): void {
    this.$emit("onIndicatorClicked", data);
  }

  //  @Getters
  get isLessThanLimit(): boolean {
    return this.rows.length <= this.pageLimit;
  }

  get skeletonStructure(): object {
    return { "table-row": "table-cell@4" };
  }

  //  @Methods
  cellData(row: DataQualityRow, header: DataQualityHeader, index: number): any {
    return {
      column: header.value,
      columnName: header.text,
      rowIndex: row.key,
      type: header.type ?? "",
      value: row[header.value].value,
      link: row[header.value].link,
      align: header.align,
    };
  }

  headerClasses(header: any): string[] {
    return [
      header.class,
      {
        sortable: header.sortable,
        "no-sort": this.sortBy !== header.value,
      },
    ];
  }

  headerStyles(header: any): any {
    return {
      width: header.width ? header.width : "auto",
      "min-width": header.width ? header.width : "auto",
    };
  }

  isNotVesselColumn(column: string): boolean {
    return Boolean(column !== "vesselName" && column !== "speedLog");
  }

  isSpeedLogColumn(column: string): boolean {
    return Boolean(column === "speedLog");
  }

  sort(value: any): void {
    if (this.sortBy === value) {
      if (this.sortDesc) {
        this.sortBy = "";
        this.sortDesc = false;
      } else {
        this.sortDesc = true;
      }
    } else {
      this.sortBy = value;
      this.sortDesc = false;
    }
  }
  created(): void {
    setTimeout(() => (this.isLoadingTextDisplay = true), 3000);
  }
}
